import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { FormatValue, visitHighlightsText } from '@features/campaigns';
import { ReactNode } from 'react';
import { Highlights as BaseHighlights } from '@features/campaigns/components/Highlights';

const formatValue: FormatValue<ReactNode> = (value, key) => (
  <b key={key}>{value}</b>
);

type VisitHighlightsProps = {
  campaignName: string;
  report: Lci3Report;
};

export const VisitHighlights = (props: VisitHighlightsProps) => {
  return (
    <BaseHighlights sx={{ height: '100%' }}>
      {visitHighlightsText({
        metrics: props.report.visitMetrics,
        campaignName: props.campaignName,
        formatValues: {
          uniqueUsers: formatValue,
          projectedVisits: formatValue,
          incrementalLift: formatValue,
          incrementalVisits: formatValue,
        },
      })}
    </BaseHighlights>
  );
};
